import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Chip,
  IconButton,
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { profileSummaryStyles } from './ProfileSummary.styles';

const ProfileSummary = ({ userData, onEdit, getInitials, getRoleDisplayName, getTitleDisplayName }) => {
  return (
    <Card sx={profileSummaryStyles.card}>
      <CardContent sx={profileSummaryStyles.cardContent}>
        <Box sx={profileSummaryStyles.backgroundDecoration} />
        
        <Box sx={profileSummaryStyles.container}>
          <Avatar sx={profileSummaryStyles.avatar}>
            {getInitials(`${userData.firstName} ${userData.lastName}`)}
          </Avatar>
          
          <Box sx={profileSummaryStyles.userInfo}>
            <Typography variant="h4" sx={profileSummaryStyles.userName}>
              {userData.firstName} {userData.lastName}
            </Typography>
            
            <Box sx={profileSummaryStyles.userDetails}>
              <Chip
                label={getRoleDisplayName(userData.role)}
                sx={profileSummaryStyles.roleChip}
                onClick={() => {}}
              />
              <Typography variant="h6" sx={profileSummaryStyles.userTitle}>
                {userData.titleName || getTitleDisplayName(userData.title) || 'Belirtilmemiş'}
              </Typography>
            </Box>

            <Typography variant="body1" sx={profileSummaryStyles.startDate}>
              {userData.startDateFormatted || ''}
            </Typography>
          </Box>

          <IconButton
            onClick={onEdit}
            sx={profileSummaryStyles.editButton}
          >
            <EditIcon />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProfileSummary; 